// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuButton_root__2iBP0","hamburgerInner":"MenuButton_hamburgerInner__3CxP9","blue":"MenuButton_blue__3Ni49","white":"MenuButton_white__BP2oI"};